import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { Curriculum } from './components/Curriculum';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-white font-body selection:bg-forest selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Benefits data-id="element-3" />
      <Curriculum data-id="element-4" />
      <Testimonials data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Pricing data-id="element-7" />
      <PurchasePopup data-id="element-8" />
    </div>;
}